// DepartmentDropdown.js

import React, { useEffect, useRef, useState, useCallback } from "react";
import { Form, Select, Input } from 'antd';
import DepartmentsApi from '../Apis/DepartmentsApi';

const DepartmentDropdown = ({disabled }) => {

    const [departments, setDepartments] = useState([]);
    const [loading, setLoading] = useState(false);
    const [TotalPageNew, setTotalPageNew] = useState(null);
    const [page, setPage] = useState(0);

    const fetchDepartments = async () => {
        try {
            setLoading(true);
            DepartmentsApi.ListDepartments(page, 10)
                .then((response) => {
                    // setDepartments(response?.payloadDto);
                    setTotalPageNew(response.totalPages);
                    setDepartments(prevDepartments => [...prevDepartments, ...response?.payloadDto]);

                    setPage(prevPage => prevPage + 1);
                    setLoading(false);

                })
                .catch((err) => {
                    console.log(err);
                });
        } catch (error) {
            console.error('Error fetching departments:', error);
        } finally {
            setLoading(false);
        }
    };
    const handleScroll = (e) => {
        const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
        const nearBottom = e.target.scrollHeight - e.target.scrollTop <= e.target.clientHeight + 1; // Add a small buffer
        if (bottom || nearBottom) {
            if (TotalPageNew > page) {
                fetchDepartments();
            }
        }
    };
    useEffect(() => {

        fetchDepartments();
    }, []);

    return (
        <><Form.Item
            name="institutionId"
            label="Department *"
            className="text-lable"
            rules={[
                {
                    required: true,
                    message: "Please Select Department.",
                },
            ]}
        >
            <Select
                disabled={disabled}
                className="control-Select mb-1"
                placeholder="Select Department"
                onPopupScroll={handleScroll} // Add scroll event listener
            >
                {departments.map((option, index) => (
                    <Select.Option key={option.id} value={option.id}>
                        {option.institutionName}
                    </Select.Option>
                ))}
                {loading && (
                    <Select.Option disabled key="loading" value="loading">
                        Loading...
                    </Select.Option>
                )}
            </Select>

        </Form.Item>
           </>
    );
};

export default DepartmentDropdown;
